const CUSTOM_ASSETS_BASE = "assets/images/instructions/custom";

export const PAGE_IDS = [
 "m301",
 "m302",
 "m303",
 "m304",
 "m305",
 "m306",
 "m307",
 "m308",
];

export const MISSION_THREE_PAGE_COUNT = PAGE_IDS.length;

export const OVERLAY_SIZE_PRESETS = {
 sm: { overlayLeftPercent: 51, overlayTopPercent: 89.5 },
 md: { overlayLeftPercent: 53, overlayTopPercent: 89.5 },
 lg: { overlayLeftPercent: 57, overlayTopPercent: 89.5 },
};

// Overlay coordinates are defaults/fallbacks for the nav hint.
// When a page has a bubble, the instructions plugin anchors the nav hint to that bubble.
export const OVERLAY_BY_PAGE = {
 m301: { overlayLeftPercent: 59, overlayTopPercent: 90, showBackKey: false },
 m302: { overlayLeftPercent: 61.5, overlayTopPercent: 90, showBackKey: false },
 m303: { overlayLeftPercent: 52, overlayTopPercent: 90 },
 m304: { overlayLeftPercent: 51, overlayTopPercent: 90 },
 m305: { overlayLeftPercent: 48, overlayTopPercent: 90 },
 m306: { overlayLeftPercent: 48.5, overlayTopPercent: 90 },
 m307: { overlayLeftPercent: 54, overlayTopPercent: 90 },
 m308: { overlayLeftPercent: 51, overlayTopPercent: 90 },
};

export const DEFAULT_PAGE_UI = {
 showPilot: false,
};

export const PAGE_UI_BY_PAGE = {
 m301: { showPilot: true },
};

export const BUBBLE_DEFAULT_LAYOUT = {
 wrapperLeftPercent: 32.5,
 wrapperBottomPercent: 8,
 minWidthPercent: 36,
 maxWidthPercent: 52,
 fontSizeVw: 0.85,
 padding: "0.9vw 1.2vw 2.4vw 1.2vw",
 tailBottomVw: -1.5,
 tailLeftVw: -1.5,
 tailWidthVw: 9.4,
 tailHeightVw: 2.5,
};

export const PILOT_LAYOUT_ADJUSTMENTS = {
 bubbleMaxWidthPercent: 38,
 overlayLeftOffsetPercent: -4,
};

export const FELLOW_EMOTION_SOURCES = {
 "hq-happy": `${CUSTOM_ASSETS_BASE}/hq-happy.svg`,
 "hq-impressed": `${CUSTOM_ASSETS_BASE}/hq-impressed.svg`,
 "hq-neutral": `${CUSTOM_ASSETS_BASE}/hq-neutral.svg`,
 "hq-speaking": `${CUSTOM_ASSETS_BASE}/hq-speaking.svg`,
};

export const MISSION_THREE_BACKGROUND_SRC = `${CUSTOM_ASSETS_BASE}/background.svg`;
export const MISSION_THREE_PILOT_SRC = `${CUSTOM_ASSETS_BASE}/driver.svg`;
